import {post} from '../utils/request'

export default {
    listAll: function (query, paginate) {
        return post("/admin/deviceType/list", {...query, ...paginate});
    },
    getAll: function () {
        return post("/admin/deviceType/getAll", {});
    },
    listNames: function() {
        return post("/admin/deviceType/listAllName", {});
    },
    findByName: function(name) {
        return post("/admin/deviceType/listByName", {name});
    },
    findById: function (id) {
        return post("/admin/deviceType/findById", {id});
    },
    findLast: function() {
        return post("/admin/deviceType/last", {});
    },
    create: function (device) {
        return post("/admin/deviceType/create", device);
    },
    update: function (device) {
        return post("/admin/deviceType/update", device);
    },
    deleteById: function (id) {
        return post("/admin/deviceType/del", {id});
    },

}
